export enum Roles {
    EMPLOYEE = 'EMPLOYEE',
    MODERATOR = 'MODERATOR'
}
